import { ApplicationState } from "..";
import { UserEntity } from "./state";

export const getMyUser = (state: ApplicationState): UserEntity | undefined => state.session.user && 
    Object.values(state.entities.users.items).find(u => u.username === state.session.user?.username);
